module.exports = __webpack_public_path__ + "media/images/official/special_exchange_01-1d73017cf6a4443059562b4386cc54bb.png";